<script setup lang="ts">
import { connectStats } from 'instantsearch.js/es/connectors';
import {
  StatsConnectorParams,
  StatsWidgetDescription,
} from 'instantsearch.js/es/connectors/stats/connectStats';
import { computed } from 'vue';

import { useWidget } from '@/composables/instant-search/useWidget';

const { state } = useWidget<StatsWidgetDescription, StatsConnectorParams>(
  { connector: connectStats },
  computed(() => ({})),
);
</script>

<template>
  <div v-if="!state?.nbHits" class="no-search-results" data-test="no-search-results">
    <div>
      <strong>Nuts! We found no matches for {{ `'${state?.query || 'this query'}'` }}!</strong>
    </div>
  </div>
</template>
